import { useState } from 'react'
import styled from 'styled-components'

import ByAddress   from './ByAddress'
import ByOwnerName from './ByOwnerName'
import ByTaxNumber from './ByTaxNumber'

const Container =  styled.div`
  display: flex;
  flex-direction: column;
  height: 100%
`
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex: none;
  margin-top: 1rem;
`
export default function TextSearchDialog({searchType, onCancel, onSubmit}) {
  const [ownerName, setOwnerName] = useState('');
  const [parcelId, setParcelId] = useState('');
  const [streetNumber, setStreetNumber] = useState('');
  const [streetName, setStreetName] = useState('');

  const submitButtonHandler = (e) => {
    //console.log("text search type= " + searchType);
    let items = {};
    // setting all parameters needed to query server
    switch (searchType) {
      case 'Search by Tax Number':
        items = {
          parcelId: parcelId.trim()
        }
        break;

      case 'Search by Owner Name':
        items = {
          ownerName: ownerName.trim()
        }
        break;

      case 'Search by Address':
        items = {
          streetNumber: streetNumber.trim(),
          streetName: streetName.trim()
        }
        break;
      default:

    }
    //console.log(items);
    onSubmit(items);
  }

  //console.log(searchType);

  let searchDialogType = null;
  switch (searchType) {
    case 'Search by Tax Number':
      searchDialogType = (
        <ByTaxNumber
          parcelId={parcelId}
          onParcelIdChange={setParcelId}
        />
      );
      break;

    case 'Search by Owner Name':
      searchDialogType = (
        <ByOwnerName
          ownerName={ownerName}
          onOwnerNameChange={setOwnerName}
        />
      );
      break;

    case 'Search by Address':
      searchDialogType = (
        <ByAddress
          streetNumber={streetNumber}
          streetName={streetName}
          onStreetNumberChange={setStreetNumber}
          onStreetNameChange={setStreetName}
        />
      );
      break;
    default:

  }

  return (
    <Container>
      <div style={{flex: "none"}}> {searchType} </div>

      {searchDialogType}

      <ButtonContainer>
        <button onClick={onCancel}>cancel</button>
        <button onClick={submitButtonHandler}>submit</button>
      </ButtonContainer>
    </Container>
  )
}
